export function zip<T, U>(a: T[], b: U[]): [T, U][] {
  return a.map((_, i) => [a[i], b[i]])
}

export function stripCarriageReturn(text: string) {
  /**
   * Remove the carriage return from the text.
   * @param {string} text
   * @returns {string}
   */
  return text.replaceAll('\r\n', '\n').replaceAll('\r', '\n')
}

const UUID_V7_REGEX = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i

/**
 * Validates whether the provided value is a UUID v7.
 * @param {unknown} uuid -- The value to validate.
 * Since this can come from a custom property, it could be any type.
 * @returns {boolean}
 */
export function validateUUID(uuid: unknown): boolean {
  if (typeof uuid !== 'string') {
    return false
  }
  return UUID_V7_REGEX.test(uuid)
}
